import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import { useStore } from "vuex";
import { computed, onBeforeUnmount, customRef, watch } from "vue";
import Length from "../../../source/js/shared/models/Geometry/Length";
import ValidationMessage from "./UI/ValidationMessage.vue";
import {formatForInputField, stripNonNumeric} from "@/functions/numbers";
import {addSizeToDataLayer} from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import MessageContainer from "@/components/UI/MessageContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CutoutPosition',
  setup(__props) {

const store = useStore();

const isCutoutValid = computed(() => store.getters.isCutoutValid);
const getCutoutValidationMessage = computed(() => store.getters.getCutoutValidationMessage);
const shapeSupportCutoutRotation = computed(() => store.getters.shapeSupportCutoutRotation);
const cutoutOutsideModel = computed(() => store.getters.cutoutOutsideModel);
const lastGeneratedConfiguration = computed(() => store.getters.lastGeneratedConfiguration);
const cutoutOffsetLeft = computed( () => store.getters.cutoutOffsetLeft );
const cutoutOffsetBottom = computed( () => store.getters.cutoutOffsetBottom );
const cutoutShape = computed( () => store.getters.cutoutShape );
const cutoutRotation = computed( () => store.getters.cutoutRotation );

const rotation = customRef(() => {
	return {
		get: () => cutoutRotation.value,
		set: (value) => {
			if ( value.length === 0 ) return;

			store.commit('updateCutoutRotation', stripNonNumeric( value ));
			store.commit('updateUsingDefaultCutoutDimensions', false);
		},
	};
});

const offsetLeft = customRef(() => {
	return {
		get: () => formatForInputField( new Length( cutoutOffsetLeft.value ).in_cm() ),
		set: (value: string|number) => {
			store.commit('updateCutoutOffsetLeft', Length.from_cm( stripNonNumeric(value) ).in_mm() );
			store.commit('updateUsingDefaultCutoutDimensions', false );
		},
	};
});

const offsetBottom = customRef(() => {
	return {
		get: () => formatForInputField( new Length( cutoutOffsetBottom.value ).in_cm() ),
		set: (value: string|number) => {
			store.commit('updateCutoutOffsetBottom', Length.from_cm( stripNonNumeric(value) ).in_mm() );
			store.commit('updateUsingDefaultCutoutDimensions', false );
		},
	};
});

watch(cutoutShape, async( newShape, previousShape ) => {
	if ( newShape !== previousShape ) {
		store.commit('resetCutoutDimension', previousShape );
	}
});

if (lastGeneratedConfiguration.value.cutout) {
	store.commit('updateUsingDefaultCutoutDimensions', false);
}

document.addEventListener('focusin', (event) =>
	store.commit('updateFocusedElement', event)
);

onBeforeUnmount(() => {
	document.removeEventListener('focusin', () =>
		store.commit('updateFocusedElement')
	);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ShapeInputFieldsWrapper, null, {
      legend: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$i18n.cutout.position.title), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(DimensionInput, {
          inputRef: "cutoutOffsetLeft",
          id: "cutoutOffsetLeft",
          name: "cutoutOffsetLeft",
          unit: "cm",
          label: _ctx.$i18n.cutout.position.offset_left,
          invalid: !isCutoutValid.value('cutoutOffsetLeft') || !isCutoutValid.value('cutoutOffset'),
          onBlur: () => _unref(addSizeToDataLayer)('cutoutOffsetLeft', +offsetLeft.value, `${cutoutShape.value} (cutout)`),
          modelValue: offsetLeft.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((offsetLeft).value = $event))
        }, null, 8, ["label", "invalid", "onBlur", "modelValue"]),
        _createVNode(DimensionInput, {
          inputRef: "cutoutOffsetBottom",
          id: "cutoutOffsetBottom",
          name: "cutoutOffsetBottom",
          unit: "cm",
          label: _ctx.$i18n.cutout.position.offset_bottom,
          invalid: !isCutoutValid.value('cutoutOffsetBottom') || !isCutoutValid.value('cutoutOffset'),
          onBlur: () => _unref(addSizeToDataLayer)('cutoutOffsetBottom', +offsetBottom.value, `${cutoutShape.value} (cutout)`),
          modelValue: offsetBottom.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((offsetBottom).value = $event))
        }, null, 8, ["label", "invalid", "onBlur", "modelValue"]),
        (shapeSupportCutoutRotation.value)
          ? (_openBlock(), _createBlock(DimensionInput, {
              key: 0,
              inputRef: "cutoutRotation",
              id: "cutoutRotation",
              name: "cutoutRotation",
              type: "number",
              unit: "°",
              label: _ctx.$i18n.cutout.position.rotation,
              onBlur: () => _unref(addSizeToDataLayer)('cutoutRotation', +rotation.value, `${cutoutShape.value} (cutout)`),
              modelValue: rotation.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rotation).value = $event)),
              step: 1,
              invalid: false
            }, null, 8, ["label", "onBlur", "modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageContainer, null, {
      default: _withCtx(() => [
        (!isCutoutValid.value('cutoutOffset'))
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 0,
              "input-id": "cutoutOffset"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getCutoutValidationMessage.value('cutoutOffset')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isCutoutValid.value('cutoutOffsetLeft'))
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 1,
              "input-id": "cutoutOffsetLeft"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getCutoutValidationMessage.value('cutoutOffsetLeft')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isCutoutValid.value('cutoutOffsetBottom'))
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 2,
              "input-id": "cutoutOffsetBottom"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getCutoutValidationMessage.value('cutoutOffsetBottom')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(ValidationMessage, { type: "notice" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$i18n.cutoutNotice), 1)
          ]),
          _: 1
        }),
        (cutoutOutsideModel.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 3,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.cutoutOutsideShapeNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})